import type { CreateSetup, Setup } from '@here/api'
import { createResource, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import * as v from 'valibot'
import { useList } from '../List/state'
import { handleCreateSetup } from './handleCreateSetup'

export enum FormSteps {
	details = 'details',
	confirm = 'confirm',
	success = 'success',
}

export function useCreate() {
	// TODO rename these varibales
	const [setupBeingEdited, setSetupBeingEdited] = createSignal<
		CreateSetup | undefined
	>()
	const [isCreateOpen, setIsCreateOpen] = createSignal(false)
	const [createSuccess, setCreateSuccess] = createSignal(false)
	const [createError, setCreateError] = createSignal('')
	const [step, setStep] = createSignal<FormSteps>(FormSteps.details)
	const [newSetup, setNewSetup] = createSignal<CreateSetup | undefined>()
	const [creatingSetup, createSetup] = createSignal<CreateSetup>()
  const { refetchCurrent } = useService(useList)()

	// TODO see if these functionshould be in effects, and also see if creating an effect here behaves as a singleton using random numbers
	const onCreateSuccess = () => {
		createSetup(undefined)
		setStep(FormSteps.success)
		setNewSetup(undefined)
		setSetupBeingEdited(undefined)
		setCreateSuccess(true)
		setCreateError('')
    refetchCurrent()
	}

	const onCreateError = (message: string) => {
		setStep(FormSteps.success)
		setCreateError(message)
		setCreateSuccess(false)
	}

	const [createSetupResource, { refetch: refetchCreate }] = createResource(
		() => ({
			creatingSetup: creatingSetup(),
			setupBeingEdited: setupBeingEdited(),
		}),
		({ creatingSetup, setupBeingEdited }) =>
			handleCreateSetup(onCreateSuccess, onCreateError)(
				creatingSetup,
				setupBeingEdited,
			),
	)

	const completeDetailStep = (setup: CreateSetup) => {
		setNewSetup(setup)
		setStep(FormSteps.confirm)
	}

	const submitSetup = () => {
		createSetup(newSetup())
	}

	const editSetup = (setup: Setup) => {
		setNewSetup(setup)
		setSetupBeingEdited(setup)
		setIsCreateOpen(true)
	}

	const openCreateSetup = () => {
		setIsCreateOpen(true)
		setSetupBeingEdited(undefined)
		setStep(FormSteps.details)
	}

	const isEditing = () => {
		const uuidSchema = v.pipe(v.string(), v.uuid())
		return v.safeParse(uuidSchema, newSetup()?.id).success
	}

	return {
		setupBeingEdited,
		completeDetailStep,
		createError,
		createSetup,
		createSetupResource,
		createSuccess,
		editSetup,
		isCreateOpen,
		isEditing,
		newSetup,
		openCreateSetup,
		refetchCreate,
		setIsCreateOpen,
		setNewSetup,
		setStep,
		step,
		submitSetup,
	}
}
